import { io } from 'socket.io-client';
import { isDemoSession } from './mockData';

const resolveSocketUrl = () => {
  if (process.env.REACT_APP_SOCKET_URL) {
    return process.env.REACT_APP_SOCKET_URL;
  }

  const host = window.location.hostname;
  const isLocal = host === 'localhost' || host === '127.0.0.1';

  return isLocal ? 'http://localhost:5000' : window.location.origin;
};

const SOCKET_URL = resolveSocketUrl();

class WebSocketService {
  constructor() {
    this.socket = null;
    this.connected = false;
    this.listeners = new Map();
  }

  connect(userId) {
    if (isDemoSession()) {
      return;
    }

    if (this.socket?.connected) {
      return;
    }

    this.socket = io(SOCKET_URL, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    this.socket.on('connect', () => {
      console.log('✅ WebSocket conectado');
      this.connected = true;
      this.socket.emit('join', userId);
    });

    this.socket.on('disconnect', () => {
      console.log('❌ WebSocket desconectado');
      this.connected = false;
    });

    this.socket.on('connect_error', (error) => {
      console.error('❌ Erro de conexão WebSocket:', error);
    });

    // Eventos de posição
    this.socket.on('vehicle_position', (data) => {
      this.emit('position_update', data);
    });

    // Eventos de alertas
    this.socket.on('alert_received', (data) => {
      this.emit('new_alert', data);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.connected = false;
      this.listeners.clear();
    }
  }

  // Adicionar listener para eventos
  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  // Remover listener
  off(event, callback) {
    if (this.listeners.has(event)) {
      const callbacks = this.listeners.get(event);
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    }
  }

  // Emitir evento para listeners
  emit(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => callback(data));
    }
  }

  // Enviar atualização de posição
  sendPositionUpdate(data) {
    if (this.socket?.connected) {
      this.socket.emit('position_update', data);
    }
  }

  // Enviar novo alerta
  sendAlert(data) {
    if (this.socket?.connected) {
      this.socket.emit('new_alert', data);
    }
  }

  isConnected() {
    return this.connected;
  }
}

export default new WebSocketService();
